import React, { useState } from 'react';
import styles from './Sidebar.module.css'
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { BsArrowsExpandVertical } from "react-icons/bs";
import { RxDashboard } from "react-icons/rx";
import { RiDashboardLine } from "react-icons/ri";
import { GoDatabase } from "react-icons/go";
import { PiNotepadLight } from "react-icons/pi";
import { FiSettings } from "react-icons/fi";
import { GiPencilRuler } from "react-icons/gi";
import { VscGraphLine } from "react-icons/vsc";
import { TbReportSearch } from "react-icons/tb";
import { RiLetterSpacing2 } from "react-icons/ri";
import { IoIosCalendar } from "react-icons/io";
import { ImTable } from "react-icons/im";
import { MdOutlineFactory } from "react-icons/md";
import logo from '../icons/logo.png'
import logo2 from '../icons/logo2.png'
import { useTheme } from '../ThemeContext';
import { useAuth } from '../auth/AuthContext';
import {Routes, Route, NavLink } from "react-router-dom";
import { MdOutlineContactSupport } from "react-icons/md";
import { TbHexagonLetterAFilled } from "react-icons/tb"; //A
import { TbHexagonLetterRFilled } from "react-icons/tb"; //R
import { TbHexagonLetterSFilled } from "react-icons/tb"; //S
import { TbHexagonLetterZFilled } from "react-icons/tb"; //Z
import { FaMapMarkedAlt } from "react-icons/fa";
import { GrMapLocation } from "react-icons/gr";
import { MdSpellcheck } from "react-icons/md";
import { BsBootstrapReboot } from "react-icons/bs";
import { TbBrandZulip } from "react-icons/tb";
import { MdOutlineVpnKey } from "react-icons/md";
import { MdOutlineDashboard } from "react-icons/md";
import { FaWindowClose } from "react-icons/fa";
import { currentVersion, releaseNotes } from '../releaseNotes';







const Sidebar = () => {
    const { theme } = useTheme();
    const { user } = useAuth();
    const [isExpanded, setExpanded] = useState(false);
    const [releaseNotesOpen, setReleaseNotesOpen] = useState(false);
    const userInitials = ((user?.email || '').split('@')[0].slice(0, 2) || 'ME').toUpperCase();
    const releaseEntries = [...releaseNotes].reverse();

    const toggleSidebar = () => {
      setExpanded(!isExpanded);
    };
  return (
    <>
        <aside className={`${styles.sidebar} ${styles[theme]} ${isExpanded ? styles.expanded : styles.retracted}`}>
        {isExpanded ? (
        <>
            
            <img className={styles.image} src={theme === 'light' ? logo : logo2} alt="logo" />
            <div className={styles.group}>
            <NavLink to="/" className={`${styles.iconExpanded} ${styles[theme]}`}><MdOutlineDashboard  style={{fontSize: '32px'}} /></NavLink>
            <NavLink to="/maps" className={`${styles.iconExpanded} ${styles[theme]}`}><GrMapLocation style={{fontSize: '28px'}} /></NavLink>
            <NavLink to="/actions" className={`${styles.iconExpanded} ${styles[theme]}`}><MdOutlineFactory   style={{fontSize: '30px'}}/></NavLink>
            {/* <NavLink to="/calendar" className={`${styles.iconExpanded} ${styles[theme]}`}><IoIosCalendar   style={{fontSize: '30px'}}/></NavLink> */}
            <NavLink to="/reports" className={`${styles.iconExpanded} ${styles[theme]}`}><BsBootstrapReboot   style={{fontSize: '32px'}}/></NavLink>
            <NavLink to="/zones" className={`${styles.iconExpanded} ${styles[theme]}`}><TbBrandZulip  style={{fontSize: '30px'}}/></NavLink>
            <NavLink to="/remote-access" className={`${styles.iconExpanded} ${styles[theme]}`}><MdOutlineVpnKey style={{fontSize: '30px'}}/></NavLink>
            <NavLink to="/user" className={`${styles.iconExpanded} ${styles[theme]}`}>
              <span className={styles.userBadgeExpanded}>{userInitials}</span>
            </NavLink>
            </div>
            <button type="button" className={`${styles.versionButton} ${styles[theme]}`} onClick={() => setReleaseNotesOpen(true)}>
              <b>{currentVersion}</b>
            </button>
            {/* <div className={`${styles.iconExpanded} ${styles[theme]}`}onClick={toggleSidebar}><BsArrowsExpandVertical style={{fontSize: '30px'}}/></div>  */}
            
            
        </>
        ) : (
        <>
            <img className={styles.image} src={theme === 'light' ? logo : logo2} alt="logo" />
            <div className={styles.group}>
                <NavLink to="/" className={`${styles.icon} ${styles[theme]}`}><MdOutlineDashboard  style={{fontSize: '30px'}} /></NavLink>
                <NavLink to="/maps" className={`${styles.icon} ${styles[theme]}`}><GrMapLocation  style={{fontSize: '25px'}} /></NavLink>
                <NavLink to="/actions" className={`${styles.icon} ${styles[theme]}`}><MdSpellcheck   style={{fontSize: '30px'}}/></NavLink>
                <NavLink to="/reports" className={`${styles.icon} ${styles[theme]}`}><BsBootstrapReboot  style={{fontSize: '25px'}}/></NavLink>
                <NavLink to="/zones" className={`${styles.icon} ${styles[theme]}`}><TbBrandZulip  style={{fontSize: '27px'}}/></NavLink>
                <NavLink to="/remote-access" className={`${styles.icon} ${styles[theme]}`}><MdOutlineVpnKey style={{fontSize: '27px'}}/></NavLink>
                <NavLink to="/user" className={`${styles.icon} ${styles[theme]}`}>
                  <span className={styles.userBadge}>{userInitials}</span>
                </NavLink>
                
             </div>
             <button type="button" className={`${styles.versionButton} ${styles[theme]}`} onClick={() => setReleaseNotesOpen(true)}>
               <b>{currentVersion}</b>
             </button>
             {/* <div className={`${styles.icon2} ${styles[theme]}`}onClick={toggleSidebar}><BsArrowsExpandVertical style={{fontSize: '30px'}}/></div>  */}
        </>

        )}
            
        </aside>

        <Dialog
          open={releaseNotesOpen}
          onClose={() => setReleaseNotesOpen(false)}
          maxWidth="md"
          fullWidth
          PaperProps={{
            className: `${styles.releaseNotesDialog} ${styles[theme]}`,
          }}
        >
          <DialogTitle className={styles.releaseNotesHeader}>
            <div>
              <Typography variant="h6" component="div">
                Release Notes
              </Typography>
            </div>
            <IconButton onClick={() => setReleaseNotesOpen(false)} className={styles.releaseNotesClose}>
              <FaWindowClose />
            </IconButton>
          </DialogTitle>

          <DialogContent dividers>
            {releaseEntries.map((release) => (
              <div key={release.version} className={styles.releaseVersionBlock}>
                <Typography variant="h6" className={styles.releaseVersionTitle}>
                  {release.version}
                </Typography>
                {release.date ? (
                  <Typography variant="body2" className={styles.releaseNotesDate}>
                    {release.date}
                  </Typography>
                ) : null}

                <div className={styles.releaseNotesSection}>
                  <Typography variant="subtitle1" className={styles.releaseNotesSectionTitle}>
                    Added
                  </Typography>
                  <ul className={styles.releaseNotesList}>
                    {(release.added || ['Add new release notes here.']).map((item) => (
                      <li key={`${release.version}-added-${item}`}>{item}</li>
                    ))}
                  </ul>
                </div>

                <div className={styles.releaseNotesSection}>
                  <Typography variant="subtitle1" className={styles.releaseNotesSectionTitle}>
                    Fixed
                  </Typography>
                  <ul className={styles.releaseNotesList}>
                    {(release.fixed || ['Add fixed items here.']).map((item) => (
                      <li key={`${release.version}-fixed-${item}`}>{item}</li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </DialogContent>
        </Dialog>
    
    </>

    
  )
}

export default Sidebar
